"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useActive = void 0;
var _react = require("react");
var _callAllHandlers = require("../../util/callAllHandlers");
/**
 * Provides a css-in-js alternative to using the native :active selector.
 * Works on non-button elements!
 *
 * Spread all the resulting handlers onto the target element. Make sure to pass
 * along any custom handlers into this function so they are composed together.
 */
const useActive = function () {
  let {
    onMouseEnter: providedOnMouseEnter,
    onMouseDown: providedOnMouseDown,
    onMouseLeave: providedOnMouseLeave
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const [isMouseDown, setIsMouseDown] = (0, _react.useState)(false);
  const [isMouseWithin, setIsMouseWithin] = (0, _react.useState)(false);
  const onMouseDown = (0, _react.useMemo)(() => (0, _callAllHandlers.callAllHandlers)(providedOnMouseDown, () => {
    setIsMouseDown(true);
  }), [providedOnMouseDown]);
  const onMouseEnter = (0, _react.useMemo)(() => (0, _callAllHandlers.callAllHandlers)(providedOnMouseEnter, () => {
    setIsMouseWithin(true);
  }), [providedOnMouseEnter]);
  const onMouseLeave = (0, _react.useMemo)(() => (0, _callAllHandlers.callAllHandlers)(providedOnMouseLeave, () => {
    setIsMouseWithin(false);
  }), [providedOnMouseLeave]);

  // Can't expect the mouseup to be fired directly on the element.
  // The user could mouseleave and then mouseup.
  (0, _react.useEffect)(() => {
    const onMouseUp = () => {
      setIsMouseDown(false);
    };
    document.addEventListener("mouseup", onMouseUp);
    return () => {
      document.removeEventListener("mouseup", onMouseUp);
    };
  }, []);
  return {
    isActive: isMouseDown && isMouseWithin,
    onMouseDown,
    onMouseEnter,
    onMouseLeave
  };
};
exports.useActive = useActive;
//# sourceMappingURL=useActive.js.map